import React from 'react'
import HeroHeading from '../Headings/HeroHeading'
import BookACallButton from '../Buttons/Specials/BookACallButton'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

const ROOFING_MODAL_PROPS = {
    meetingTitle: 'Book a Call With a Direct Mail Expert Now',
    formName: 'Roofing Direct Mail Strategy Call',
}

const defaultContent = {
    brand: { show: true, name: 'Open Letter Marketing' },
    headline: 'Direct Mail Marketing for Roofers',
    highlightWord: 'Roofers',
    subheadline: 'Win More Roofing Jobs with Proven, Targeted Mail Campaigns',
    description:
        'Roofing leads go cold fast. With OLM, your mailers reach homeowners in just 2 days — while competitors are still knocking doors. Our direct mail campaigns put you in front of the right homeowners and drive the calls, inspections, and signed contracts your business needs.',
    cta: { label: 'Get Started Now', href: '/products' },
}

export default function RoofingHero(props) {
    const {
        headline = defaultContent.headline,
        highlightWord = defaultContent.highlightWord,
        subheadline = defaultContent.subheadline,
        description = defaultContent.description,
        cta = defaultContent.cta,
    } = props || {}

    const splitHeadline = (() => {
        const idx = headline.indexOf(highlightWord)
        if (idx < 0) return { before: headline, highlight: '', after: '' }
        return {
            before: headline.slice(0, idx),
            highlight: headline.slice(idx, idx + highlightWord.length),
            after: headline.slice(idx + highlightWord.length),
        }
    })()

    return (
        <section className="bg-[linear-gradient(180deg,#FAFAFA_0%,#FFF8EA_100%)]">
            <div className="container mx-auto px-4 py-12 md:py-16 lg:py-20">
                <div className="flex flex-col-reverse md:grid md:grid-cols-2 gap-10 lg:gap-12 items-center">
                    {/* Left column: Brand, Headline, Copy, CTA */}
                    <div className="max-w-2xl flex flex-col-reverse md:block">
                        <div className="text-center md:text-left">
                            <p className="bg-[#FFF8E9] text-base text-[#3F454F] px-5 font-semibold rounded-lg max-w-fit mx-auto lg:mx-0 mb-2">
                                Be the Roofer That Stands Out
                            </p>
                            <HeroHeading>
                                {splitHeadline.before}
                                <span className="text-olm">
                                    {splitHeadline.highlight}
                                </span>
                                {splitHeadline.after}
                            </HeroHeading>
                            <div className="mt-6 text-base sm:text-lg font-bold tracking-wide text-black md:max-w-md">
                                {subheadline}
                            </div>

                            <p className="mt-5 sm:mt-6 text-base sm:text-lg leading-relaxed text-black font-medium">
                                {description}
                            </p>
                        </div>

                        {cta?.label ? (
                            <div className="max-w-xs md:max-w-sm mt-2 mb-8 md:mt-8 md:mb-0 mx-auto md:mx-0">
                                <BookACallButton
                                    scheme="default"
                                    Modal={HomepageBookCallLeadModal}
                                    modalProps={ROOFING_MODAL_PROPS}>
                                    {cta.label}
                                </BookACallButton>
                            </div>
                        ) : null}
                    </div>

                    {/* Right column: Image cluster */}
                    <div className="relative">
                        {/* Main image container with large TR radius */}
                        <div className="relative z-10 ml-auto h-full w-[92%] md:w-full">
                            <img
                                src={
                                    '/assets/roofers/roofers-main-image-final.png'
                                }
                                alt={'Roofing campaign hero'}
                                className="h-full w-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
